import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../../Styles/ann-tokens.css";
import "../../Styles/marketing-base.css";
import "./Header.css";

const NAV = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/why-ann", label: "Why Ann" },
  { to: "/compare", label: "Compare" },
  { to: "/pricing", label: "Pricing" },
  { to: "/for/staffing-firms", label: "For agencies" },
  { to: "/resource", label: "Resources" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Strengthen the nav border once the page scrolls
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`topnav${scrolled ? " scrolled" : ""}${open ? " open" : ""}`}>
      <Link to="/" className="ann-logo-link" aria-label="Ann — home">
        <img
          src={`${process.env.PUBLIC_URL}/ann-lockup-light.svg`}
          alt="Ann"
          className="ann-logo"
        />
      </Link>

      <div className="links">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => (isActive ? "is-active" : undefined)}
          >
            {item.label}
          </NavLink>
        ))}
      </div>

      <div className="right">
        <Link to="/contact-us" className="btn btn-primary btn-sm">
          Book a demo
        </Link>
      </div>

      <button
        className="nav-toggle"
        aria-label="Menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
}
